import { PropsWithChildren } from 'react'
import Styles from 'components/FirstTimeExperienceModal/components/Footer/Footer.module.scss'
import cx from 'classnames'
import { StickyFooterProps } from 'providers/StickyFooterProvider/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const StickyFooter = ({
  children,
  isFloating = false,
  className,
}: PropsWithChildren<StickyFooterProps & { className?: string }>) => {
  const { isMobile } = useResponsiveDesign()
  return (
    <div className={cx(Styles.container, className, { [Styles.floating]: isFloating && !isMobile })}>{children}</div>
  )
}

export const Footer = ({ children }: PropsWithChildren) => <div className={Styles.footer}>{children}</div>

export const FooterButtons = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
  <div className={cx(Styles.buttons, className)}>{children}</div>
)
